import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  card: {
    height: '100%',
    position: 'relative',
    overflow: 'visible',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  statsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 12,
    paddingTop: 12,
    borderTop: '1px solid #e0e0e0',
  },
  statItem: {
    textAlign: 'center',
  },
  bigNumber: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1,
    marginBottom: 8,
  },
  label: {
    fontSize: '0.875rem',
    color: '#666',
    fontWeight: 500,
  },
  subtitle: {
    fontSize: '0.75rem',
    color: '#999',
    marginTop: 4,
  },
});

interface StatsCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  color?: string;
  stats?: Array<{
    label: string;
    value: number | string;
    color?: string;
  }>;
  chip?: {
    label: string;
    color: 'success' | 'warning' | 'error' | 'info' | 'default';
  };
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, subtitle, color = '#1976d2', stats, chip }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box className={classes.header}>
          <Typography variant="h6" style={{ fontWeight: 600, color: '#333' }}>
            {title}
          </Typography>
          {chip && <Chip label={chip.label} color={chip.color} size="small" />}
        </Box>

        <Typography className={classes.bigNumber} style={{ color }}>
          {value}
        </Typography>

        {subtitle && (
          <Typography className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}

        {stats && stats.length > 0 && (
          <Box className={classes.statsRow}>
            {stats.map((stat, index) => (
              <Box key={index} className={classes.statItem}>
                <Typography
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    color: stat.color || '#666',
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography className={classes.label}>{stat.label}</Typography>
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default StatsCard;
